/* ==========================================================================
   SHOPIFY POD THEME — VANILLA JS INTERACTION ENGINE
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  initLanguageEngine();
  initMobileMenu();
  initCartDrawer();
  initVariantPicker();
  initQuantitySelectors();
  initProductGallery();
  initAccordions();
  initModals();
  initStickyAddToCart();
  initAddToCartForms();
  initAnchorNavigation();
  initHeroHotspots();
});

/* --------------------------------------------------------------------------
   0. INTERNATIONALIZATION ENGINE (BROWSER AUTO-DETECT + MANUAL ES / EN)
   -------------------------------------------------------------------------- */
window.currentLanguage = 'es';

const translations = {
  es: {
    announcement: 'PRODUCCIÓN BAJO DEMANDA SOSTENIBLE // ENTREGA EN 7-10 DÍAS CON TRACKING // ENVÍO GRATIS +60€',
    nav_collection: 'Colección',
    nav_tee: '01. Camiseta',
    nav_hoodie: '02. Sudadera',
    nav_bundle: 'Pack Ahorro',
    nav_faq: 'FAQ',
    cart_label: 'CESTA',
    lang_label: 'IDIOMA:',

    hero_subheading: 'BLADING.SHOP // AGGRESSIVE SKATING WEAR',
    hero_heading: 'ROPA DE PATINAJE AGRESIVO. HECHA POR BLADERS.',
    hero_text: 'Dos prendas diseñadas con el fit holgado que necesitas para patinar agusto y la resistencia para aguantar los rozones de cada sesión. Cero postureo corporativo.',
    hero_btn1: '01. CAMISETA OVERSIZED',
    hero_btn2: '02. SUDADERA BORDADA',
    hero_trust1: 'Corte Boxy & Oversized para Libertad de Movimiento',
    hero_trust2: 'Hecho Bajo Demanda: Cero Sobreproducción Textil (7-10 Días)',
    hero_trust3: 'Tracking Express en Todo Momento + Cambios de Talla 14 Días',
    hero_badge: 'LIVE SESSION // MADRID & BCN',
    hero_stl_badge: 'SHOP THE LOOK (2 PRENDAS)',
    hero_stl_p1_tag: '01. DROP // EN ESTA SESIÓN',
    hero_stl_p1_title: 'Camiseta Oversized "Blading"',
    hero_stl_p1_spec: '170 GSM // 100% Algodón Peinado',
    hero_stl_p1_btn: 'VER PRENDA →',
    hero_stl_p2_tag: '02. DROP // EN ESTA SESIÓN',
    hero_stl_p2_title: 'Sudadera Bordada "Blading"',
    hero_stl_p2_spec: '280 GSM // Bordado HD en Relieve',
    hero_stl_p2_btn: 'VER PRENDA →',

    grid_subheading: 'EL DROP // BLADING WEAR',
    grid_heading: 'NUESTRA COLECCIÓN PARA PATINAR',
    grid_subtitle: 'Corte holgado para no limitar tus movimientos y tejido resistente para aguantar la calle.',
    prod1_title: 'CAMISETA OVERSIZED "BLADING"',
    prod1_subtitle: '170 G/M² // 100% ALGODÓN PEINADO RINGSPUN',
    prod1_desc: 'Diseñada para la calle y el skatepark. Caída holgada limpia, hombros caídos y costuras laterales reforzadas para resistir las sesiones más intensas.',
    prod1_spec1: '• Fit: Oversized Boxy Drop-Shoulder (libertad total en trucos)',
    prod1_spec2: '• Costuras laterales dobles reforzadas anti-rasgones',
    prod1_spec3: '• Hecho bajo demanda: Cero sobreproducción textil',
    prod1_pod: 'Hecho bajo demanda para ti (7-10 días)',
    prod1_btn: 'VER CAMISETA & TALLAS',

    prod2_title: 'SUDADERA BORDADA "BLADING"',
    prod2_subtitle: '280 G/M² // FELPA SUAVE // BORDADO HD',
    prod2_desc: 'Sudadera clásica de cuello redondo con el logotipo bordado en hilo de alta densidad en el pecho. Estructura con cuerpo, ideal para patinar en invierno o romper la noche.',
    prod2_spec1: '• 280GSM: Felpa gruesa y cálida para sesiones de frío',
    prod2_spec2: '• Bordado HD en relieve: nunca se despega ni se borra',
    prod2_spec3: '• Hecho bajo demanda: Cero sobreproducción textil',
    prod2_pod: 'Hecho bajo demanda para ti (7-10 días)',
    prod2_btn: 'VER SUDADERA & TALLAS',

    bundle_badge: 'PACK COMPLETO // ENVÍO GRATIS',
    bundle_heading: 'EL OUTFIT COMPLETO: CAMISETA + SUDADERA',
    bundle_subheading: 'Consigue ambas piezas con un ahorro inmediato y envío express gratuito.',
    bundle_item1_label: 'Talla Camiseta:',
    bundle_item2_label: 'Talla Sudadera:',
    bundle_total_label: 'PRECIO DEL PACK:',
    bundle_savings: 'AHORRAS 3€ + ENVÍO GRATIS',
    bundle_btn: '🛒 AÑADIR PACK COMPLETO (84,99€)',
    bundle_guarantee: '✓ Hecho bajo demanda para ti (cero sobreproducción). Entrega habitual en 7 a 10 días laborables con tracking individual + Envío Gratis.',

    value_prop1_title: 'PRODUCCIÓN BAJO DEMANDA (POD)',
    value_prop1_text: 'Hecho especialmente para ti tras tu compra. Cero sobreproducción textil y cero residuos. No acumulamos stock innecesario; cuidamos cada costura.',
    value_prop2_title: 'TRANSPARENCIA TOTAL: 7 A 10 DÍAS',
    value_prop2_text: 'Sin letra pequeña: 2-4 días de confección artesanal + 3-5 días de envío express. Lo más común es recibirlo en 7 a 10 días con seguimiento individual.',
    value_prop3_title: 'RESISTENCIA & CAMBIO TALLA (14D)',
    value_prop3_text: 'Tejidos pesados reforzados a prueba de rozones y caídas en street. ¿Dudas con la talla? Tienes 14 días para cambio fácil sin preguntas.',

    story_subheading: 'BLADING CULTURE // SIN POSTUREO',
    story_heading: 'DESDE LA COMUNIDAD DE PATINAJE AGRESIVO.',
    story_p1: 'Sabemos lo que es tirarte al suelo en un bordillo, rasgar una camiseta barata en el primer intento y querer ropa que de verdad represente nuestra cultura de calle.',
    story_p2: 'blading.shop no es una marca corporativa de moda urbana diseñada en una oficina. Nació del contenido real en TikTok, de las sesiones en el skatepark y del amor por el patinaje agresivo.',
    story_p3: 'Elegimos únicamente 2 prendas básicas (Camiseta Oversized + Sudadera Crewneck Bordada) con cortes caídos pensados para que te muevas sin restricciones al planchar trucos y telas reforzadas para aguantar la caña del día a día.',
    story_stat_label1: 'CULTURA BLADING',
    story_stat_label2: 'FELPA BORDADA',
    story_stat_label3: 'FIT CALLEJERO',

    comp_subheading: 'ESPECIFICACIONES TÉCNICAS',
    comp_heading: 'COMPARATIVA: CAMISETA VS SUDADERA',
    comp_subtitle: 'Analiza las diferencias clave para elegir la prenda ideal para tus necesidades.',
    comp_th_feat: 'CARACTERÍSTICA',
    comp_th_col1: '01. CAMISETA BLADING',
    comp_th_col2: '02. SUDADERA BORDADA',
    comp_r1_feat: 'Gramaje del Tejido',
    comp_r1_v1: '170 g/m² (Heavyweight)',
    comp_r1_v2: '280 g/m² (Felpa Suave)',
    comp_r2_feat: 'Composición',
    comp_r2_v1: '100% Algodón Peinado Ringspun',
    comp_r2_v2: '80% Algodón / 20% Poliéster Reciclado',
    comp_r3_feat: 'Corte & Fit',
    comp_r3_v1: 'Oversized / Boxy callejero',
    comp_r3_v2: 'Regular cómodo con costura doble',
    comp_r4_feat: 'Acabado / Logo',
    comp_r4_v1: 'Logo minimalista en el pecho',
    comp_r4_v2: 'Bordado HD en relieve en el centro',
    comp_r5_feat: 'Uso Ideal',
    comp_r5_v1: 'Patinar en verano / Sesiones de diario',
    comp_r5_v2: 'Invierno / Noches / Patinar con frío',
    comp_price_label: 'Precio',
    comp_action_label: 'Acción Directa',
    comp_btn1: 'VER CAMISETA (32,99€)',
    comp_btn2: 'VER SUDADERA (54,99€)',

    ugc_subheading: 'COMMUNITY // REAL FITS',
    ugc_heading: 'PRUEBA SOCIAL: ASÍ QUEDA EN LA CALLE',
    ugc_subtitle: 'Fotos reales de compradores vistiendo nuestras dos piezas esenciales.',
    ugc_fit1: '1.82M // TALLA L (CAMISETA)',
    ugc_quote1: 'El corte oversized es perfecto para patinar suelto. La tela aguanta caídas sin deformarse y el cuello no se da de sí.',
    ugc_fit2: '1.88M // TALLA XL (SUDADERA)',
    ugc_quote2: 'El bordado del pecho se ve brutal de cerca. Es abrigada de verdad (280GSM) y perfecta para patinar en invierno.',
    ugc_fit3: '1.75M // TALLA M (CAMISETA)',
    ugc_quote3: 'Envío rápido y el pedido llegó impecable. La camiseta tiene una caída pesada increíble.',
    ugc_verified: 'Comprador verificado ✓',

    faq_heading: 'PREGUNTAS FRECUENTES // TRANSPARENCIA TOTAL',
    faq_subheading: 'DUDAS FRECUENTES',
    faq_subtitle: 'Resolvemos todas tus preguntas sobre nuestra ropa para patinar, envíos y devoluciones.',
    faq1_q: '¿Cuánto tarda exactamente en llegar mi pedido?',
    faq1_a: 'Transparencia radical: tu prenda se produce bajo demanda especialmente para ti, reduciendo la sobreproducción textil. La confección y estampado tardan de 2 a 4 días laborables, y el envío express con seguimiento individual tarda de 3 a 5 días. En total, lo más común y habitual es recibirlo en 7 a 10 días laborables. Te enviamos el número de seguimiento por email para que veas en todo momento la ruta de tu paquete.',
    faq2_q: '¿Qué pasa si la talla no me queda bien para patinar?',
    faq2_a: 'Cero problemas. Si necesitas una talla más para un corte aún más oversized o una menos, tienes 14 días para cambio de talla sin preguntas raras. Te lo gestionamos directamente de blader a blader.',
    faq3_q: '¿La ropa aguanta caídas contra el suelo o raspones de bordillo?',
    faq3_a: 'Diseñada por y para patinadores: la camiseta cuenta con 170 g/m² de algodón peinado con costuras dobles laterales reforzadas, y la sudadera está fabricada en felpa gruesa de 280 g/m² con un bordado de hilo de alta densidad que nunca se desgasta ni se despega.',
    faq4_q: '¿Hacéis envíos a todo el mundo (internacionales)?',
    faq4_a: 'Sí. La comunidad de patinaje agresivo es global. Enviamos a toda Europa, Reino Unido, Estados Unidos y resto del mundo con seguimiento certificado individual.',
    faq5_q: '¿Cómo debo lavar las prendas para que duren años?',
    faq5_a: 'Lávalas siempre del revés a máximo 30ºC con colores similares. Evita la secadora industrial y no planches directamente sobre el estampado ni el bordado. Así mantendrán su tacto y caída sesión tras sesión.',

    news_subheading: 'INNER CLUB // DROPS EXCLUSIVOS',
    news_heading: 'ÚNETE AL CLUB BLADING',
    news_text: 'Recibe acceso prioritario a nuevos drops de ropa para patinar y un 10% de descuento en tu primera compra.',
    news_placeholder: 'Tu correo electrónico...',
    news_btn: 'OBTENER 10% OFF',
    news_disclaimer: 'Cero spam. Desuscripción en 1-click cuando quieras.',

    footer_tagline: 'Marca de ropa urbana nacida de la comunidad de patinaje agresivo. Ropa resistente con el fit holgado que necesitas para la calle y el park.',
    footer_col2_title: 'COLECCIÓN BLADING',
    footer_link1: '01. Camiseta Oversized (32,99€)',
    footer_link2: '02. Sudadera Bordada (54,99€)',
    footer_link3: 'Pack Outfit Completo (84,99€)',
    footer_link4: 'Preguntas Frecuentes',
    footer_col3_title: 'TRANSPARENCIA & INFO',
    footer_link5: 'Envíos & Devoluciones (14 días)',
    footer_link6: 'Guía de Tallas Completa',
    footer_link7: 'Sobre blading.shop',
    footer_link8: 'Política de Privacidad',
    footer_link9: 'Términos y Condiciones',
    footer_copy: '© 2026 blading.shop. Todos los derechos reservados.',

    atc_btn_text: 'AÑADIR A LA CESTA',
    atc_sold_out: 'AGOTADO',
    size_guide_btn: 'Guía de Tallas',
    sg_title: 'GUÍA DE TALLAS // GUÍA DE MEDIDAS',
    sg_intro: 'Nuestras prendas siguen un patrón <strong>Boxy / Oversized Fit</strong>. Te recomendamos seleccionar tu talla habitual para un fit relajado o una talla menos si prefieres un ajuste más ajustado.',
    sg_h4_1: '01. GUÍA MEDIDAS — CAMISETA OVERSIZED (170GSM)',
    sg_h4_2: '02. GUÍA MEDIDAS — SUDADERA BORDADA (280GSM)',
    sg_th_size: 'TALLA',
    sg_th_chest: 'PECHO (CM)',
    sg_th_length: 'LARGO (CM)',
    sg_th_sleeve: 'MANGA (CM)',
    sg_note: '* Tolerancia de producción POD de +/- 1.5 cm por lavado pre-tratado.',

    cart_title: 'TU CESTA',
    cart_empty: 'Tu cesta está vacía en este momento.',
    cart_empty_btn: 'VER PRENDAS DISPONIBLES',
    cart_subtotal: 'SUBTOTAL:',
    cart_shipping_note: 'Impuestos incluidos. Envío calculado en el pago.',
    cart_checkout_btn: 'PROCEDER AL PAGO SEGURO 🔒',
    cart_trust_note: '🔒 Garantía de devolución en 14 días • Pago cifrado SSL',
    cart_pod_notice: '<strong>Hecho bajo demanda para ti:</strong> Cero sobreproducción textil. Entrega habitual en <strong>7 a 10 días laborables</strong> con tracking.',
    cart_upsell_tag: '⚡ IMPULSO // OFERTA EXCLUSIVA',
    cart_upsell_btn: '+ AÑADIR (5,99€)',
    cart_upsell_added: '✓ Añadido',
    cart_bundle_discount: '⚡ Descuento Pack Outfit:',
    cart_remove: 'Eliminar'
  },
  en: {
    announcement: 'SUSTAINABLE ON-DEMAND WEAR // 7-10 DAYS TRACKED DELIVERY // FREE SHIPPING OVER 60€',
    nav_collection: 'Collection',
    nav_tee: '01. T-Shirt',
    nav_hoodie: '02. Hoodie',
    nav_bundle: 'Bundle Deal',
    nav_faq: 'FAQ',
    cart_label: 'CART',
    lang_label: 'LANGUAGE:',

    hero_subheading: 'BLADING.SHOP // AGGRESSIVE SKATING WEAR',
    hero_heading: 'AGGRESSIVE SKATING STREETWEAR. MADE BY BLADERS.',
    hero_text: 'Two essential pieces engineered with the loose fit you need to skate freely and the durability to handle rough street sessions. Zero corporate fake.',
    hero_btn1: '01. OVERSIZED TEE',
    hero_btn2: '02. EMBROIDERED HOODIE',
    hero_trust1: 'Boxy & Oversized Cut for Complete Trick Mobility',
    hero_trust2: 'Made On Demand: Zero Textile Waste (7-10 Days)',
    hero_trust3: 'Tracked Express Shipping + 14-Day Free Size Exchange',
    hero_badge: 'LIVE SESSION // MADRID & BCN',
    hero_stl_badge: 'SHOP THE LOOK (2 ITEMS)',
    hero_stl_p1_tag: '01. DROP // IN THIS SESSION',
    hero_stl_p1_title: 'Oversized Tee "Blading"',
    hero_stl_p1_spec: '170 GSM // 100% Combed Cotton',
    hero_stl_p1_btn: 'VIEW ITEM →',
    hero_stl_p2_tag: '02. DROP // IN THIS SESSION',
    hero_stl_p2_title: 'Embroidered Hoodie "Blading"',
    hero_stl_p2_spec: '280 GSM // HD Relief Embroidery',
    hero_stl_p2_btn: 'VIEW ITEM →',

    grid_subheading: 'THE DROP // BLADING WEAR',
    grid_heading: 'OUR SKATING ESSENTIALS',
    grid_subtitle: 'Baggy cut designed not to restrict your tricks and heavy fabric to withstand the streets.',
    prod1_title: 'OVERSIZED TEE "BLADING"',
    prod1_subtitle: '170 GSM // 100% COMBED RINGSPUN COTTON',
    prod1_desc: 'Engineered for street and skatepark sessions. Clean loose drop-shoulder drape and reinforced double side seams built to survive heavy falls.',
    prod1_spec1: '• Fit: Oversized Boxy Drop-Shoulder (unrestricted trick motion)',
    prod1_spec2: '• Reinforced double side seams against rough concrete',
    prod1_spec3: '• Made on demand: Zero textile overproduction',
    prod1_pod: 'Made on demand for you (7-10 days)',
    prod1_btn: 'VIEW T-SHIRT & SIZES',

    prod2_title: 'EMBROIDERED CREWNECK "BLADING"',
    prod2_subtitle: '280 GSM // SOFT FLEECE // HD EMBROIDERY',
    prod2_desc: 'Heavyweight crewneck with dense white embroidery across the chest. Built tough, ideal for cold skate sessions or street cruising.',
    prod2_spec1: '• 280GSM: Heavy warm fleece for cold street sessions',
    prod2_spec2: '• HD 3D Embroidery: never peels, cracks or fades in wash',
    prod2_spec3: '• Made on demand: Zero textile overproduction',
    prod2_pod: 'Made on demand for you (7-10 days)',
    prod2_btn: 'VIEW HOODIE & SIZES',

    bundle_badge: 'FULL OUTFIT // FREE SHIPPING',
    bundle_heading: 'THE FULL OUTFIT: T-SHIRT + HOODIE',
    bundle_subheading: 'Get both skate essentials with immediate savings and free tracked delivery.',
    bundle_item1_label: 'T-Shirt Size:',
    bundle_item2_label: 'Hoodie Size:',
    bundle_total_label: 'BUNDLE PRICE:',
    bundle_savings: 'SAVE 3€ + FREE SHIPPING',
    bundle_btn: '🛒 ADD FULL PACK (84.99€)',
    bundle_guarantee: '✓ Made on demand for you (zero overproduction). Typical 7-10 business day tracked delivery + Free Shipping.',

    value_prop1_title: 'MADE ON DEMAND (POD)',
    value_prop1_text: 'Crafted specifically for you after ordering. Zero textile overproduction and no wasted stock. Ethical, high-durability streetwear.',
    value_prop2_title: 'RADICAL TRANSPARENCY: 7-10 DAYS',
    value_prop2_text: 'No fine print: 2-4 days craft production + 3-5 days express courier. Most orders arrive in 7 to 10 business days with individual tracking.',
    value_prop3_title: 'STREET DURABILITY & 14-DAY EXCHANGES',
    value_prop3_text: 'Heavyweight fabrics built for concrete ledges and slams. Sizing doubt? You get 14 days for hassle-free size exchanges, no hassle.',

    story_subheading: 'BLADING CULTURE // NO CORPORATE FAKE',
    story_heading: 'BORN FROM THE AGGRESSIVE INLINE COMMUNITY.',
    story_p1: 'We know the feeling of slamming onto concrete ledges, ripping cheap shirts on the first try, and wanting gear that genuinely represents our raw street culture.',
    story_p2: 'blading.shop is not a corporate streetwear label designed in an office cubicle. It grew out of raw skate sessions, TikTok community edits, and our lifelong passion for aggressive inline.',
    story_p3: 'We curated just two core pieces (Oversized Tee + Embroidered Crewneck) with loose boxy drapes engineered for unrestricted trick movement and heavyweight fabrics built to survive daily street abuse.',
    story_stat_label1: 'BLADING CULTURE',
    story_stat_label2: 'EMBROIDERED FLEECE',
    story_stat_label3: 'BOXY STREET FIT',

    comp_subheading: 'TECHNICAL SPECIFICATIONS',
    comp_heading: 'COMPARISON: TEE VS HOODIE',
    comp_subtitle: 'Review key differences and technical details to choose the right gear for your sessions.',
    comp_th_feat: 'FEATURE',
    comp_th_col1: '01. BLADING TEE',
    comp_th_col2: '02. EMBROIDERED HOODIE',
    comp_r1_feat: 'Fabric Weight',
    comp_r1_v1: '170 GSM (Heavyweight)',
    comp_r1_v2: '280 GSM (Soft Fleece)',
    comp_r2_feat: 'Composition',
    comp_r2_v1: '100% Combed Ringspun Cotton',
    comp_r2_v2: '80% Cotton / 20% Recycled Poly',
    comp_r3_feat: 'Cut & Fit',
    comp_r3_v1: 'Oversized / Street Boxy',
    comp_r3_v2: 'Comfort Regular with double seam',
    comp_r4_feat: 'Finish / Logo',
    comp_r4_v1: 'Minimalist chest print',
    comp_r4_v2: 'High-Density 3D chest embroidery',
    comp_r5_feat: 'Ideal Use',
    comp_r5_v1: 'Summer skating / Daily sessions',
    comp_r5_v2: 'Winter / Night sessions / Cold weather',
    comp_price_label: 'Price',
    comp_action_label: 'Direct Action',
    comp_btn1: 'VIEW T-SHIRT (32.99€)',
    comp_btn2: 'VIEW HOODIE (54.99€)',

    ugc_subheading: 'COMMUNITY // REAL FITS',
    ugc_heading: 'SOCIAL PROOF: STREET LOOK & FIT',
    ugc_subtitle: 'Real community photos wearing our two essential skating pieces.',
    ugc_fit1: '1.82M // SIZE L (TEE)',
    ugc_quote1: 'The oversized cut is perfect for skating loose. The fabric survives heavy slams without stretching and the collar holds its shape.',
    ugc_fit2: '1.88M // SIZE XL (HOODIE)',
    ugc_quote2: 'The chest embroidery looks insane up close. Genuinely warm (280GSM) and ideal for cold winter street sessions.',
    ugc_fit3: '1.75M // SIZE M (TEE)',
    ugc_quote3: 'Super fast delivery and arrived in pristine condition. The t-shirt has an incredible heavyweight drape.',
    ugc_verified: 'Verified Buyer ✓',

    faq_heading: 'FREQUENTLY ASKED QUESTIONS // RADICAL TRANSPARENCY',
    faq_subheading: 'FREQUENT QUESTIONS',
    faq_subtitle: 'Clear answers about our skating apparel, on-demand crafting, delivery times and easy exchanges.',
    faq1_q: 'How long does my order take to arrive?',
    faq1_a: 'Radical transparency: your garment does not sit in a warehouse. It is produced on demand specifically for you, preventing textile waste and overproduction. Production takes 2 to 4 business days, and express courier shipping takes 3 to 5 business days. In total, typical delivery is 7 to 10 business days. You receive full tracking by email as soon as it leaves the workshop.',
    faq2_q: 'What if the size doesn’t fit baggy enough for skating?',
    faq2_a: 'Zero stress. If you want a bigger size for an extra oversized fit or need to swap, you have 14 days for hassle-free size exchanges directly handled blader to blader.',
    faq3_q: 'Can these clothes handle concrete slams and ledge scrapes?',
    faq3_a: 'Built by and for bladers: the t-shirt is 170 GSM combed cotton with reinforced double side seams, and the hoodie is 280 GSM heavyweight soft fleece with high-density relief embroidery that will never peel or fade.',
    faq4_q: 'Do you ship worldwide (internationally)?',
    faq4_a: 'Yes! The aggressive inline skating scene is global. We ship to the UK, USA, Europe and worldwide with individual certified tracking.',
    faq5_q: 'How should I wash the clothes so they last for years?',
    faq5_a: 'Always wash inside out at maximum 30ºC (86ºF) with similar colors. Avoid industrial tumble dryers and never iron directly on embroidery or print. They will keep their premium drape and feel spot after spot.',

    news_subheading: 'INNER CLUB // EXCLUSIVE DROPS',
    news_heading: 'JOIN THE BLADING CLUB',
    news_text: 'Get early access to upcoming drops and 10% off your first order.',
    news_placeholder: 'Your email address...',
    news_btn: 'GET 10% OFF',
    news_disclaimer: 'Zero spam. 1-click unsubscribe anytime.',

    footer_tagline: 'Streetwear brand forged in the aggressive inline community. Heavyweight apparel with the loose cut you need for street and park sessions.',
    footer_col2_title: 'BLADING COLLECTION',
    footer_link1: '01. Oversized Tee (32.99€)',
    footer_link2: '02. Embroidered Hoodie (54.99€)',
    footer_link3: 'Complete Outfit Deal (84.99€)',
    footer_link4: 'Frequently Asked Questions',
    footer_col3_title: 'TRANSPARENCY & INFO',
    footer_link5: 'Shipping & Returns (14-day exchange)',
    footer_link6: 'Full Size Guide',
    footer_link7: 'About blading.shop',
    footer_link8: 'Privacy Policy',
    footer_link9: 'Terms and Conditions',
    footer_copy: '© 2026 blading.shop. All rights reserved.',

    atc_btn_text: 'ADD TO CART',
    atc_sold_out: 'SOLD OUT',
    size_guide_btn: 'Size Guide',
    sg_title: 'SIZE GUIDE // MEASUREMENTS',
    sg_intro: 'Our garments feature an authentic <strong>Boxy / Oversized Fit</strong>. We suggest ordering your normal size for a comfortable relaxed drape or one size down for a standard fit.',
    sg_h4_1: '01. MEASUREMENTS GUIDE — OVERSIZED TEE (170GSM)',
    sg_h4_2: '02. MEASUREMENTS GUIDE — EMBROIDERED HOODIE (280GSM)',
    sg_th_size: 'SIZE',
    sg_th_chest: 'CHEST (CM)',
    sg_th_length: 'LENGTH (CM)',
    sg_th_sleeve: 'SLEEVE (CM)',
    sg_note: '* POD manufacturing tolerance of +/- 1.5 cm due to pre-treated wash.',

    cart_title: 'YOUR CART',
    cart_empty: 'Your cart is currently empty.',
    cart_empty_btn: 'VIEW AVAILABLE ITEMS',
    cart_subtotal: 'SUBTOTAL:',
    cart_shipping_note: 'Taxes included. Shipping calculated at checkout.',
    cart_checkout_btn: 'PROCEED TO SECURE CHECKOUT 🔒',
    cart_trust_note: '🔒 14-day exchange guarantee • SSL encrypted checkout',
    cart_pod_notice: '<strong>Made on demand for you:</strong> Zero textile overproduction. Typical delivery in <strong>7 to 10 business days</strong> with tracking.',
    cart_upsell_tag: '⚡ IMPULSE // EXCLUSIVE DEAL',
    cart_upsell_btn: '+ ADD (5.99€)',
    cart_upsell_added: '✓ Added',
    cart_bundle_discount: '⚡ Bundle Savings (Outfit Deal):',
    cart_remove: 'Remove'
  }
};

function initLanguageEngine() {
  let initialLang = 'es';
  try {
    const saved = localStorage.getItem('blading_lang');
    if (saved === 'es' || saved === 'en') {
      initialLang = saved;
    } else {
      const browserLang = (navigator.language || (navigator.languages && navigator.languages[0]) || 'es').toLowerCase();
      initialLang = browserLang.startsWith('es') ? 'es' : 'en';
    }
  } catch (e) {
    console.log('Language detection notice:', e);
  }

  applyLanguage(initialLang);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-lang-btn');
    if (btn && btn.dataset.lang) {
      e.preventDefault();
      const targetLang = btn.dataset.lang;
      applyLanguage(targetLang);
      try {
        localStorage.setItem('blading_lang', targetLang);
      } catch (err) {}
    }
  });
}

function applyLanguage(lang) {
  if (!translations[lang]) lang = 'es';
  window.currentLanguage = lang;
  document.documentElement.lang = lang;
  const t = translations[lang];

  document.querySelectorAll('.js-lang-btn').forEach(b => {
    b.classList.toggle('is-active', b.dataset.lang === lang);
  });

  const setText = (selector, text) => {
    document.querySelectorAll(selector).forEach(el => {
      el.textContent = text;
    });
  };
  const setHtml = (selector, html) => {
    document.querySelectorAll(selector).forEach(el => {
      el.innerHTML = html;
    });
  };

  // 1. Navigation & Announcement
  setText('.js-announcement-text a, .js-announcement-text', t.announcement);
  setText('.js-nav-collection', t.nav_collection);
  setText('.js-nav-tee', t.nav_tee);
  setText('.js-nav-hoodie', t.nav_hoodie);
  setText('.js-nav-bundle', t.nav_bundle);
  setText('.js-nav-faq', t.nav_faq);
  setText('.js-cart-label', t.cart_label);
  setText('.js-i18n-lang-label', t.lang_label);

  // 2. Hero Section
  setText('.js-hero-subheading', t.hero_subheading);
  setText('.js-hero-heading', t.hero_heading);
  setText('.js-hero-text', t.hero_text);
  setText('.js-hero-btn1', t.hero_btn1);
  setText('.js-hero-btn2', t.hero_btn2);
  setText('.js-hero-trust-1', t.hero_trust1);
  setText('.js-hero-trust-2', t.hero_trust2);
  setText('.js-hero-trust-3', t.hero_trust3);
  setText('.js-hero-stl-badge', t.hero_stl_badge);
  setText('.js-stl-p1-tag', t.hero_stl_p1_tag);
  setText('.js-stl-p1-title', t.hero_stl_p1_title);
  setText('.js-stl-p1-spec', t.hero_stl_p1_spec);
  setText('.js-stl-p1-btn', t.hero_stl_p1_btn);
  setText('.js-stl-p2-tag', t.hero_stl_p2_tag);
  setText('.js-stl-p2-title', t.hero_stl_p2_title);
  setText('.js-stl-p2-spec', t.hero_stl_p2_spec);
  setText('.js-stl-p2-btn', t.hero_stl_p2_btn);

  // 3. Product Grid
  setText('.js-grid-subheading', t.grid_subheading);
  setText('.js-grid-heading', t.grid_heading);
  setText('.js-grid-subtitle', t.grid_subtitle);
  setText('.js-prod1-title', t.prod1_title);
  setText('.js-prod1-subtitle', t.prod1_subtitle);
  setText('.js-prod1-desc', t.prod1_desc);
  setText('.js-prod1-spec1', t.prod1_spec1);
  setText('.js-prod1-spec2', t.prod1_spec2);
  setText('.js-prod1-spec3', t.prod1_spec3);
  setText('.js-prod1-pod-tag', t.prod1_pod);
  setText('.js-view-tee-btn', t.prod1_btn);

  setText('.js-prod2-title', t.prod2_title);
  setText('.js-prod2-subtitle', t.prod2_subtitle);
  setText('.js-prod2-desc', t.prod2_desc);
  setText('.js-prod2-spec1', t.prod2_spec1);
  setText('.js-prod2-spec2', t.prod2_spec2);
  setText('.js-prod2-spec3', t.prod2_spec3);
  setText('.js-prod2-pod-tag', t.prod2_pod);
  setText('.js-view-hoodie-btn', t.prod2_btn);

  // 4. Bundle Offer
  setText('.bundle-header .badge', t.bundle_badge);
  setText('.bundle-header h2', t.bundle_heading);
  setText('.bundle-header p', t.bundle_subheading);
  setText('label[for="bundle-size-tee"]', t.bundle_item1_label);
  setText('label[for="bundle-size-hoodie"]', t.bundle_item2_label);
  setText('.js-bundle-total-label', t.bundle_total_label);
  setText('.js-bundle-savings', t.bundle_savings);
  setText('.js-add-bundle-btn', t.bundle_btn);
  setText('.js-bundle-guarantee', t.bundle_guarantee);

  // 5. Value Props
  const propCards = document.querySelectorAll('.value-prop-card');
  if (propCards.length >= 3) {
    const p1H4 = propCards[0].querySelector('h4');
    const p1P = propCards[0].querySelector('p');
    if (p1H4) p1H4.textContent = t.value_prop1_title;
    if (p1P) p1P.textContent = t.value_prop1_text;

    const p2H4 = propCards[1].querySelector('h4');
    const p2P = propCards[1].querySelector('p');
    if (p2H4) p2H4.textContent = t.value_prop2_title;
    if (p2P) p2P.textContent = t.value_prop2_text;

    const p3H4 = propCards[2].querySelector('h4');
    const p3P = propCards[2].querySelector('p');
    if (p3H4) p3H4.textContent = t.value_prop3_title;
    if (p3P) p3P.textContent = t.value_prop3_text;
  }

  // 6. Brand Storytelling
  setText('.js-story-subheading', t.story_subheading);
  setText('.js-story-heading', t.story_heading);
  setText('.js-story-p-1', t.story_p1);
  setText('.js-story-p-2', t.story_p2);
  setText('.js-story-p-3', t.story_p3);
  setText('.js-story-stat-label-1', t.story_stat_label1);
  setText('.js-story-stat-label-2', t.story_stat_label2);
  setText('.js-story-stat-label-3', t.story_stat_label3);

  // 7. Comparison Table
  setText('.js-comp-subheading', t.comp_subheading);
  setText('.js-comp-heading', t.comp_heading);
  setText('.js-comp-subtitle', t.comp_subtitle);
  setText('.js-comp-th-feat', t.comp_th_feat);
  setText('.js-comp-th-col1', t.comp_th_col1);
  setText('.js-comp-th-col2', t.comp_th_col2);
  setText('.js-comp-row-1 .js-comp-row-feat', t.comp_r1_feat);
  setText('.js-comp-row-1 .js-comp-row-v1', t.comp_r1_v1);
  setText('.js-comp-row-1 .js-comp-row-v2', t.comp_r1_v2);
  setText('.js-comp-row-2 .js-comp-row-feat', t.comp_r2_feat);
  setText('.js-comp-row-2 .js-comp-row-v1', t.comp_r2_v1);
  setText('.js-comp-row-2 .js-comp-row-v2', t.comp_r2_v2);
  setText('.js-comp-row-3 .js-comp-row-feat', t.comp_r3_feat);
  setText('.js-comp-row-3 .js-comp-row-v1', t.comp_r3_v1);
  setText('.js-comp-row-3 .js-comp-row-v2', t.comp_r3_v2);
  setText('.js-comp-row-4 .js-comp-row-feat', t.comp_r4_feat);
  setText('.js-comp-row-4 .js-comp-row-v1', t.comp_r4_v1);
  setText('.js-comp-row-4 .js-comp-row-v2', t.comp_r4_v2);
  setText('.js-comp-row-5 .js-comp-row-feat', t.comp_r5_feat);
  setText('.js-comp-row-5 .js-comp-row-v1', t.comp_r5_v1);
  setText('.js-comp-row-5 .js-comp-row-v2', t.comp_r5_v2);
  setText('.js-comp-price-label', t.comp_price_label);
  setText('.js-comp-action-label', t.comp_action_label);
  setText('.js-comp-btn1', t.comp_btn1);
  setText('.js-comp-btn2', t.comp_btn2);

  // 8. UGC / Social Proof
  setText('.js-ugc-subheading', t.ugc_subheading);
  setText('.js-ugc-heading', t.ugc_heading);
  setText('.js-ugc-subtitle', t.ugc_subtitle);
  setText('.js-ugc-fit-1', t.ugc_fit1);
  setText('.js-ugc-quote-1', `"${t.ugc_quote1}"`);
  setText('.js-ugc-fit-2', t.ugc_fit2);
  setText('.js-ugc-quote-2', `"${t.ugc_quote2}"`);
  setText('.js-ugc-fit-3', t.ugc_fit3);
  setText('.js-ugc-quote-3', `"${t.ugc_quote3}"`);
  setText('.js-ugc-verified', t.ugc_verified);

  // 9. FAQ Accordion (Fixed selector to match .faq-accordion-wrapper / .faq-section)
  setText('.js-faq-subheading, .faq-section .section-header .text-overline', t.faq_subheading);
  setText('.js-faq-heading, .faq-section .section-header h2', t.faq_heading);
  setText('.js-faq-subtitle, .faq-section .section-subtitle', t.faq_subtitle);
  const faqItems = document.querySelectorAll('.faq-accordion-wrapper .accordion-item, .faq-section .accordion-item, .faq-accordion .accordion-item');
  const faqs = [
    { q: t.faq1_q, a: t.faq1_a },
    { q: t.faq2_q, a: t.faq2_a },
    { q: t.faq3_q, a: t.faq3_a },
    { q: t.faq4_q, a: t.faq4_a },
    { q: t.faq5_q, a: t.faq5_a }
  ];
  faqItems.forEach((item, idx) => {
    if (faqs[idx]) {
      const btnSpan = item.querySelector('.accordion-trigger span');
      const p = item.querySelector('.accordion-content p');
      if (btnSpan) btnSpan.textContent = faqs[idx].q;
      if (p) p.textContent = faqs[idx].a;
    }
  });

  // 10. Newsletter
  setText('.js-news-subheading', t.news_subheading);
  setText('.js-news-heading', t.news_heading);
  setText('.js-news-text', t.news_text);
  document.querySelectorAll('.js-news-input').forEach(i => i.placeholder = t.news_placeholder);
  setText('.js-news-btn', t.news_btn);
  setText('.js-news-disclaimer', t.news_disclaimer);

  // 11. Footer
  setText('.js-footer-tagline', t.footer_tagline);
  setText('.js-footer-col2-title', t.footer_col2_title);
  setText('.js-footer-link-1', t.footer_link1);
  setText('.js-footer-link-2', t.footer_link2);
  setText('.js-footer-link-3', t.footer_link3);
  setText('.js-footer-link-4', t.footer_link4);
  setText('.js-footer-col3-title', t.footer_col3_title);
  setText('.js-footer-link-5', t.footer_link5);
  setText('.js-footer-link-6', t.footer_link6);
  setText('.js-footer-link-7', t.footer_link7);
  setText('.js-footer-link-8', t.footer_link8);
  setText('.js-footer-link-9', t.footer_link9);
  setText('.js-footer-copy', t.footer_copy);

  // 12. Cart Drawer
  const cartCountEl = document.querySelector('.js-cart-count');
  const count = cartCountEl ? cartCountEl.textContent : '0';
  setText('.js-cart-drawer-title', `${t.cart_title} (${count})`);
  setHtml('.js-cart-pod-text', t.cart_pod_notice);
  setText('.js-cart-subtotal-label', t.cart_subtotal);
  setText('.js-cart-shipping-note', t.cart_shipping_note);
  setText('.js-cart-checkout-btn', t.cart_checkout_btn);
  setText('.js-cart-trust-note', t.cart_trust_note);
  setText('.js-cart-upsell-wrapper .upsell-action button', t.cart_upsell_btn);
  setText('.cart-upsell-wrapper span[style*="sale"]', t.cart_upsell_tag);
  setText('.js-cart-discount-label', t.cart_bundle_discount);

  // Dynamic cart drawer elements if already open/rendered
  const emptyP = document.querySelector('.empty-cart-state p');
  const emptyA = document.querySelector('.empty-cart-state a');
  if (emptyP) emptyP.textContent = t.cart_empty;
  if (emptyA) emptyA.textContent = t.cart_empty_btn;
  document.querySelectorAll('.cart-item-remove').forEach(b => {
    b.textContent = t.cart_remove;
  });
  const upsellAdded = document.querySelector('.cart-upsell-box.is-added .upsell-action span');
  if (upsellAdded) upsellAdded.textContent = `✓ ${t.cart_upsell_added}`;

  // 13. Product Page / Variant Picker / Size Guide Modal / ATC
  document.querySelectorAll('.js-add-to-cart-btn').forEach(btn => {
    const span = btn.querySelector('.js-atc-btn-text');
    if (span) {
      span.textContent = btn.disabled ? t.atc_sold_out : t.atc_btn_text;
    }
  });
  setText('.js-size-guide-text', t.size_guide_btn);
  setText('.js-sg-title', t.sg_title);
  setHtml('.js-sg-intro', t.sg_intro);
  setText('.js-sg-h4-1', t.sg_h4_1);
  setText('.js-sg-h4-2', t.sg_h4_2);
  setText('.js-sg-th-size', t.sg_th_size);
  setText('.js-sg-th-chest', t.sg_th_chest);
  setText('.js-sg-th-length', t.sg_th_length);
  setText('.js-sg-th-sleeve', t.sg_th_sleeve);
  setText('.js-sg-note', t.sg_note);

  // 14. Product page trust badges if present
  setText('.js-trust-1-title', t.value_prop1_title + ':');
  setText('.js-trust-1-text', t.value_prop1_text);
  setText('.js-trust-2-title', t.value_prop2_title + ':');
  setText('.js-trust-2-text', t.value_prop2_text);
  setText('.js-trust-3-title', t.value_prop3_title + ':');
  setText('.js-trust-3-text', t.value_prop3_text);
}

/* --------------------------------------------------------------------------
   1. MOBILE MENU TOGGLE
   -------------------------------------------------------------------------- */
function initMobileMenu() {
  const toggleBtn = document.querySelector('.js-mobile-menu-toggle');
  const navMenu = document.querySelector('.js-site-nav');
  
  if (!toggleBtn || !navMenu) return;

  toggleBtn.addEventListener('click', () => {
    const isOpen = navMenu.classList.toggle('is-open');
    toggleBtn.setAttribute('aria-expanded', isOpen);
  });
}

/* --------------------------------------------------------------------------
   2. CART DRAWER AJAX ENGINE
   -------------------------------------------------------------------------- */
function initCartDrawer() {
  const overlay = document.querySelector('.js-cart-drawer-overlay');
  const drawer = document.querySelector('.js-cart-drawer');
  const triggers = document.querySelectorAll('.js-cart-drawer-trigger');
  const closeBtns = document.querySelectorAll('.js-cart-drawer-close');

  if (!drawer) return;

  window.openCartDrawer = function() {
    drawer.classList.add('is-active');
    if (overlay) overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  };

  window.closeCartDrawer = function() {
    drawer.classList.remove('is-active');
    if (overlay) overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  };

  triggers.forEach(btn => btn.addEventListener('click', window.openCartDrawer));
  closeBtns.forEach(btn => btn.addEventListener('click', window.closeCartDrawer));
  if (overlay) overlay.addEventListener('click', window.closeCartDrawer);

  // Cart quantity change & remove (delegated)
  document.addEventListener('click', async (e) => {
    // Quantity change in cart drawer
    if (e.target.classList.contains('js-cart-qty-change')) {
      const key = e.target.dataset.key;
      const qty = parseInt(e.target.dataset.qty, 10);
      if (!key) return;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: Math.max(qty, 0) })
        });
        await updateCartDrawerState();
      } catch(err) { console.log(err); }
    }

    // Remove item from cart drawer
    if (e.target.classList.contains('js-cart-remove')) {
      const key = e.target.dataset.key;
      if (!key) return;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        await updateCartDrawerState();
      } catch(err) { console.log(err); }
    }

    // 1-Click Upsell Add button in Cart Drawer
    if (e.target.classList.contains('js-upsell-btn')) {
      const btn = e.target;
      const variantId = btn.dataset.variantId || '57259372052858';
      const isEn = window.currentLanguage === 'en';
      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = isEn ? 'Adding...' : 'Añadiendo...';

      try {
        const vInt = parseInt(variantId, 10);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: !isNaN(vInt) && vInt > 0 ? vInt : 57259372052858, quantity: 1 })
        });
        if (res.ok) {
          btn.textContent = isEn ? '✓ Added!' : '✓ ¡Añadido!';
          btn.style.backgroundColor = 'var(--color-success)';
          btn.style.borderColor = 'var(--color-success)';
          btn.style.color = '#fff';
          await updateCartDrawerState();
        } else {
          const errData = await res.json().catch(() => ({}));
          console.warn('Upsell add error response:', errData);
          btn.disabled = false;
          btn.textContent = originalText;
        }
      } catch (err) {
        console.log('Upsell add error:', err);
        btn.disabled = false;
        btn.textContent = originalText;
      }
    }
  });
}

/* --------------------------------------------------------------------------
   3. VARIANT RADIO PICKER
   -------------------------------------------------------------------------- */
function initVariantPicker() {
  const radios = document.querySelectorAll('.js-variant-radio');
  const stickySizeDisplay = document.querySelector('.js-sticky-size');

  radios.forEach(radio => {
    radio.addEventListener('change', (e) => {
      const val = e.target.value;
      const optionContainer = e.target.closest('.variant-option');
      if (optionContainer) {
        const valDisplay = optionContainer.querySelector('.js-selected-value') ||
                           optionContainer.querySelector('.js-selected-color') ||
                           optionContainer.querySelector('.js-selected-size');
        if (valDisplay) valDisplay.textContent = val;
      }

      const name = (e.target.name || '').toLowerCase();
      if (name.includes('talla') || name.includes('size')) {
        if (stickySizeDisplay) stickySizeDisplay.textContent = (window.currentLanguage === 'en' ? 'Size ' : 'Talla ') + val;
      }
    });
  });
}

/* --------------------------------------------------------------------------
   4. QUANTITY SELECTOR (- / +)
   -------------------------------------------------------------------------- */
function initQuantitySelectors() {
  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-qty-minus')) {
      const input = e.target.parentElement.querySelector('.js-qty-input');
      if (input && parseInt(input.value) > 1) {
        input.value = parseInt(input.value) - 1;
      }
    }
    if (e.target.classList.contains('js-qty-plus')) {
      const input = e.target.parentElement.querySelector('.js-qty-input');
      if (input) {
        input.value = parseInt(input.value) + 1;
      }
    }
  });
}

/* --------------------------------------------------------------------------
   5. GALLERY THUMBNAIL SWITCHER
   -------------------------------------------------------------------------- */
function initProductGallery() {
  const mainImg = document.getElementById('GalleryMainImage');
  const thumbs = document.querySelectorAll('.js-thumb-btn');

  if (!mainImg || thumbs.length === 0) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const newSrc = thumb.dataset.fullSrc;
      if (newSrc) {
        mainImg.style.opacity = '0.4';
        mainImg.src = newSrc;
        setTimeout(() => { mainImg.style.opacity = '1'; }, 100);
      }
    });
  });
}

/* --------------------------------------------------------------------------
   6. ACCORDION / COLLAPSIBLE TOGGLE
   -------------------------------------------------------------------------- */
function initAccordions() {
  const triggers = document.querySelectorAll('.js-accordion-trigger');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.js-accordion-item');
      if (item) {
        item.classList.toggle('is-open');
      }
    });
  });
}

/* --------------------------------------------------------------------------
   7. MODAL ENGINE (SIZE GUIDE)
   -------------------------------------------------------------------------- */
function initModals() {
  const triggers = document.querySelectorAll('.js-modal-trigger');
  const closeBtns = document.querySelectorAll('.js-modal-close');

  triggers.forEach(btn => {
    btn.addEventListener('click', () => {
      const targetId = btn.dataset.modalTarget;
      const modal = document.querySelector(targetId);
      if (modal) {
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
      }
    });
  });

  closeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const modal = btn.closest('.js-modal');
      if (modal) {
        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
      }
    });
  });

  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-modal')) {
      e.target.classList.remove('is-active');
      e.target.setAttribute('aria-hidden', 'true');
    }
  });
}

/* --------------------------------------------------------------------------
   8. STICKY ADD TO CART — Intersection Observer + AJAX
   -------------------------------------------------------------------------- */
function initStickyAddToCart() {
  const stickyBar = document.querySelector('.js-sticky-atc');
  const mainBtn = document.querySelector('.js-add-to-cart-btn');
  const stickyBtn = document.querySelector('.js-sticky-atc-btn');

  // Show/hide bar using intersection observer on the main ATC button
  if (stickyBar && mainBtn) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('is-visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        } else {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0.1 });

    observer.observe(mainBtn);
  }

  // Sticky ATC button — AJAX add to cart
  if (stickyBtn) {
    stickyBtn.addEventListener('click', async () => {
      const variantId = stickyBtn.dataset.variantId || (stickyBar && stickyBar.dataset.variantId);
      if (!variantId || variantId === 'undefined' || variantId === '') {
        console.warn('Sticky ATC: No variant ID set. Configure it in Shopify Customizer.');
        if (window.openCartDrawer) window.openCartDrawer();
        return;
      }

      stickyBtn.classList.add('btn-loading');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        });
        if (res.ok) {
          await updateCartDrawerState();
        }
        if (window.openCartDrawer) window.openCartDrawer();
      } catch (err) {
        console.log('Sticky ATC error:', err);
        if (window.openCartDrawer) window.openCartDrawer();
      } finally {
        stickyBtn.classList.remove('btn-loading');
      }
    });
  }
}

/* --------------------------------------------------------------------------
   9. AJAX ADD TO CART FORMS + BUNDLE BUTTON
   -------------------------------------------------------------------------- */
function initAddToCartForms() {
  const forms = document.querySelectorAll('.js-atc-form');

  forms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      if (btn) btn.classList.add('btn-loading');

      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (res.ok) {
          await updateCartDrawerState();
          if (window.openCartDrawer) window.openCartDrawer();
        } else {
          if (window.openCartDrawer) window.openCartDrawer();
        }
      } catch (err) {
        console.log('Cart add notice:', err);
        if (window.openCartDrawer) window.openCartDrawer();
      } finally {
        if (btn) btn.classList.remove('btn-loading');
      }
    });
  });

  // Bundle button — AJAX add both products
  const bundleBtn = document.querySelector('.js-add-bundle-btn');
  if (bundleBtn) {
    bundleBtn.addEventListener('click', async () => {
      const teeSel = document.getElementById('bundle-size-tee');
      const hoodSel = document.getElementById('bundle-size-hoodie');
      let teeVariantId = teeSel ? teeSel.value : null;
      let hoodVariantId = hoodSel ? hoodSel.value : null;

      if (teeSel && isNaN(parseInt(teeVariantId, 10))) {
        const opt = teeSel.options[teeSel.selectedIndex];
        if (opt && opt.dataset.variantId) teeVariantId = opt.dataset.variantId;
      }
      if (hoodSel && isNaN(parseInt(hoodVariantId, 10))) {
        const opt = hoodSel.options[hoodSel.selectedIndex];
        if (opt && opt.dataset.variantId) hoodVariantId = opt.dataset.variantId;
      }

      const isEn = window.currentLanguage === 'en';
      const origText = bundleBtn.textContent;
      bundleBtn.classList.add('btn-loading');
      bundleBtn.textContent = isEn ? 'Adding bundle to cart...' : 'Añadiendo pack al carrito...';
      try {
        const items = [];
        const id1 = parseInt(teeVariantId, 10);
        const id2 = parseInt(hoodVariantId, 10);
        if (!isNaN(id1)) items.push({ id: id1, quantity: 1, properties: { '_bundle': 'Pack Outfit Completo' } });
        if (!isNaN(id2)) items.push({ id: id2, quantity: 1, properties: { '_bundle': 'Pack Outfit Completo' } });

        if (items.length > 0) {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });

          // Pre-apply discount code for checkout
          const discountCode = bundleBtn.dataset.discountCode || 'PACKAHORRO';
          fetch('/discount/' + discountCode).catch(() => {});

          if (res.ok) {
            await updateCartDrawerState();
          } else {
            // If collective add was rejected (e.g. inventory constraint), attempt individual adds
            for (const itm of items) {
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(itm)
              }).catch(() => {});
            }
            await updateCartDrawerState();
          }
        }
        bundleBtn.textContent = isEn ? '✓ BUNDLE ADDED TO CART!' : '✓ ¡PACK AÑADIDO A LA CESTA!';
        setTimeout(() => {
          bundleBtn.textContent = isEn ? translations.en.bundle_btn : translations.es.bundle_btn;
        }, 2200);
        if (window.openCartDrawer) window.openCartDrawer();
      } catch (err) {
        console.log('Bundle add error:', err);
        bundleBtn.textContent = origText;
        if (window.openCartDrawer) window.openCartDrawer();
      } finally {
        bundleBtn.classList.remove('btn-loading');
      }
    });
  }
}

/* --------------------------------------------------------------------------
   10. ANCHOR NAVIGATION — Fix #hash links from non-homepage pages
   -------------------------------------------------------------------------- */
function initAnchorNavigation() {
  const isHomepage = window.location.pathname === '/' || window.location.pathname === '';

  // If we are on a secondary page and the URL itself has a hash, redirect to homepage
  if (!isHomepage && window.location.hash && window.location.hash.length > 1) {
    const hash = window.location.hash;
    window.location.replace('/' + hash);
    return;
  }

  // Fix all anchor links that start with '#' so they point to /{hash} when not on homepage
  if (!isHomepage) {
    document.querySelectorAll('a[href^="#"]').forEach(link => {
      const href = link.getAttribute('href');
      if (href && href.length > 1) {
        link.setAttribute('href', '/' + href);
      }
    });
  }

  // Smooth scroll to hash target on homepage
  if (isHomepage && window.location.hash) {
    const target = document.querySelector(window.location.hash);
    if (target) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }
}

/* --------------------------------------------------------------------------
   11. HERO SHOP THE LOOK HOTSPOTS
   -------------------------------------------------------------------------- */
function initHeroHotspots() {
  const hotspots = document.querySelectorAll('.js-hero-hotspot');
  const toggleBtn = document.querySelector('.js-hero-stl-toggle');
  if (!hotspots.length) return;

  const closeAllHotspots = () => {
    hotspots.forEach(h => {
      h.classList.remove('is-active');
      const pin = h.querySelector('.js-hotspot-pin');
      if (pin) pin.setAttribute('aria-expanded', 'false');
    });
  };

  hotspots.forEach(hotspot => {
    const pin = hotspot.querySelector('.js-hotspot-pin');
    const closeBtn = hotspot.querySelector('.js-hotspot-close');

    if (pin) {
      pin.addEventListener('click', (e) => {
        e.stopPropagation();
        const wasActive = hotspot.classList.contains('is-active');
        closeAllHotspots();
        if (!wasActive) {
          hotspot.classList.add('is-active');
          pin.setAttribute('aria-expanded', 'true');
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        hotspot.classList.remove('is-active');
        if (pin) pin.setAttribute('aria-expanded', 'false');
      });
    }
  });

  if (toggleBtn) {
    toggleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const anyActive = Array.from(hotspots).some(h => h.classList.contains('is-active'));
      if (anyActive) {
        closeAllHotspots();
      } else {
        // Open the primary hotspot (the t-shirt on the skater's chest)
        const primary = hotspots[0];
        if (primary) {
          primary.classList.add('is-active');
          const pin = primary.querySelector('.js-hotspot-pin');
          if (pin) pin.setAttribute('aria-expanded', 'true');
        }
      }
    });
  }

  // Close on outside click
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.js-hero-hotspot') && !e.target.closest('.js-hero-stl-toggle')) {
      closeAllHotspots();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllHotspots();
    }
  });
}

/* --------------------------------------------------------------------------
   CART STATE UPDATER — Refreshes badge, subtotal and cart items HTML
   -------------------------------------------------------------------------- */
async function updateCartDrawerState() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    
    // Update badge count
    const badges = document.querySelectorAll('.js-cart-count');
    badges.forEach(b => b.textContent = cart.item_count);
    
    // Detect bundle items & savings
    const teeItem = cart.items.find(i => 
      i.product_id === 16195027075450 || 
      (i.handle && i.handle.includes('camiseta')) ||
      (i.title && i.title.toLowerCase().includes('camiseta'))
    );
    const hoodItem = cart.items.find(i => 
      i.product_id === 16195027566970 || 
      (i.handle && i.handle.includes('sudadera')) ||
      (i.title && i.title.toLowerCase().includes('sudadera'))
    );
    const bundleCount = (teeItem && hoodItem) ? Math.min(teeItem.quantity, hoodItem.quantity) : 0;
    const bundleSavings = bundleCount * 299; // 2.99 € discount per bundle (87.98 € -> 84.99 €)

    // Subtotal & Discount row
    const subtotalEl = document.querySelector('.js-cart-subtotal');
    const discountRow = document.querySelector('.js-cart-discount-row');
    const discountAmtEl = document.querySelector('.js-cart-discount-amount');
    const originalSubtotalEl = document.querySelector('.js-cart-subtotal-original');
    const checkoutBtn = document.querySelector('.js-cart-checkout-btn');

    if (bundleCount > 0) {
      if (cart.total_discount > 0) {
        // Shopify automatic discount is already applied on server
        if (discountRow) discountRow.style.display = 'flex';
        if (discountAmtEl) discountAmtEl.textContent = '-' + formatMoney(cart.total_discount);
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        if (originalSubtotalEl) {
          originalSubtotalEl.style.display = 'block';
          originalSubtotalEl.textContent = formatMoney(cart.original_total_price || (cart.total_price + cart.total_discount));
        }
        if (checkoutBtn) checkoutBtn.setAttribute('href', '/checkout');
      } else {
        // Calculate bundle offer price and pre-apply discount code at checkout
        const effectiveSubtotal = Math.max(cart.total_price - bundleSavings, 0);
        if (discountRow) discountRow.style.display = 'flex';
        if (discountAmtEl) discountAmtEl.textContent = '-' + formatMoney(bundleSavings);
        if (subtotalEl) subtotalEl.textContent = formatMoney(effectiveSubtotal);
        if (originalSubtotalEl) {
          originalSubtotalEl.style.display = 'block';
          originalSubtotalEl.textContent = formatMoney(cart.total_price);
        }
        if (checkoutBtn) checkoutBtn.setAttribute('href', '/checkout?discount=PACKAHORRO');
      }
    } else {
      if (discountRow) discountRow.style.display = 'none';
      if (originalSubtotalEl) originalSubtotalEl.style.display = 'none';
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if (checkoutBtn) checkoutBtn.setAttribute('href', '/checkout');
    }

    // Update free shipping progress bar & note
    const shippingThreshold = (window.themeSettings && window.themeSettings.freeShippingThreshold) ? window.themeSettings.freeShippingThreshold * 100 : 6000;
    const shippingProgress = document.querySelector('.js-free-shipping-progress');
    const shippingNote = document.querySelector('.js-free-shipping-note');
    const isEn = window.currentLanguage === 'en';
    const effectiveTotalForShipping = (bundleCount > 0 && cart.total_discount === 0) ? Math.max(cart.total_price - bundleSavings, 0) : cart.total_price;

    if (shippingProgress && shippingNote) {
      if (effectiveTotalForShipping >= shippingThreshold) {
        shippingProgress.style.width = '100%';
        shippingNote.textContent = isEn ? '🎉 Congratulations! FREE SHIPPING unlocked.' : '🎉 ¡Felicidades! Tienes ENVÍO GRATIS activado.';
      } else {
        const needed = shippingThreshold - effectiveTotalForShipping;
        const pct = Math.min(Math.round((effectiveTotalForShipping / shippingThreshold) * 100), 100);
        shippingProgress.style.width = pct + '%';
        shippingNote.textContent = isEn 
          ? `Add ${formatMoney(needed)} more to get Free Shipping`
          : `Añade ${formatMoney(needed)} más para conseguir Envío Gratis`;
      }
    }

    // Re-render cart items
    const wrapper = document.querySelector('.js-cart-items-wrapper');
    if (wrapper) {
      if (cart.item_count === 0) {
        wrapper.innerHTML = `
          <div class="empty-cart-state text-center" style="padding:40px 0;">
            <p style="font-size:1.1rem; margin-bottom:15px;">${isEn ? 'Your cart is currently empty.' : 'Tu cesta está vacía en este momento.'}</p>
            <a href="/#productos" class="btn btn-secondary js-cart-drawer-close">${isEn ? 'VIEW STREETWEAR' : 'VER PRENDAS DISPONIBLES'}</a>
          </div>`;
      } else {
        let html = '';
        cart.items.forEach(item => {
          const imgSrc = item.image ? item.image.replace(/(\.\w+)$/, '_80x100$1') : '';
          const isBundleItem = (item.properties && item.properties._bundle) || (bundleCount > 0 && (
            item.product_id === 16195027075450 || 
            item.product_id === 16195027566970 ||
            (item.title && (item.title.toLowerCase().includes('camiseta') || item.title.toLowerCase().includes('sudadera')))
          ));
          html += `
          <div class="cart-item" data-line-item-key="${item.key}">
            ${imgSrc ? `<img src="${imgSrc}" alt="${escapeHtml(item.product_title)}" class="cart-item-img" width="80" height="100">` : ''}
            <div class="cart-item-details">
              <div>
                <h4 class="cart-item-title">${escapeHtml(item.product_title)}</h4>
                <div class="cart-item-variant">${escapeHtml(item.variant_title || '')}</div>
                ${isBundleItem ? `<div style="font-size:0.68rem;font-weight:700;color:var(--color-sale);margin-top:2px;">⚡ Pack Outfit (${isEn ? 'Deal 84.99€' : 'Oferta 84,99€'})</div>` : ''}
                <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
              </div>
              <div class="cart-item-actions" style="display:flex;align-items:center;justify-content:space-between;margin-top:8px;">
                <div class="quantity-selector" style="height:32px;">
                  <button type="button" class="quantity-btn js-cart-qty-change" data-key="${item.key}" data-qty="${item.quantity - 1}">-</button>
                  <span class="quantity-input" style="line-height:32px;font-size:0.8rem;">${item.quantity}</span>
                  <button type="button" class="quantity-btn js-cart-qty-change" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
                </div>
                <button type="button" class="cart-item-remove js-cart-remove" data-key="${item.key}" style="font-size:0.75rem;text-decoration:underline;color:#888;">${isEn ? 'Remove' : 'Eliminar'}</button>
              </div>
            </div>
          </div>`;
        });
        wrapper.innerHTML = html;
      }
    }
    // Update upsell visibility and in-cart status
    const upsellWrapper = document.querySelector('.js-cart-upsell-wrapper');
    if (upsellWrapper) {
      upsellWrapper.style.display = cart.item_count > 0 ? 'block' : 'none';
      const upsellBtn = upsellWrapper.querySelector('.js-upsell-btn');
      const actionEl = upsellWrapper.querySelector('.upsell-action');
      const vId = upsellBtn ? parseInt(upsellBtn.dataset.variantId || '57259372052858', 10) : 57259372052858;
      
      const inCart = cart.items.some(i => 
        i.id === vId || 
        i.variant_id === vId || 
        i.product_id === 16199889650042 || 
        (i.handle && i.handle.includes('sticker')) ||
        (i.title && i.title.toLowerCase().includes('sticker'))
      );

      if (actionEl) {
        if (inCart) {
          actionEl.innerHTML = `<span style="font-size: 0.75rem; font-weight: bold; color: var(--color-success); display: inline-flex; align-items: center; gap: 4px;">✓ ${isEn ? 'Added' : 'Añadido'}</span>`;
          upsellWrapper.querySelector('.cart-upsell-box')?.classList.add('is-added');
        } else {
          upsellWrapper.querySelector('.cart-upsell-box')?.classList.remove('is-added');
          actionEl.innerHTML = `<button type="button" class="btn btn-primary js-upsell-btn" data-variant-id="${vId}" style="padding: 7px 12px; font-size: 0.75rem; font-weight: 800; white-space: nowrap;">+ ${isEn ? 'ADD (5.99€)' : 'AÑADIR (5,99€)'}</button>`;
        }
      }
    }
  } catch (e) {
    console.log(e);
  }
}

function formatMoney(cents) {
  return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
}

function escapeHtml(str) {
  if (!str) return '';
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

